import axios from 'axios'

export const postReferral = ({ referralDetails }) => {
  return axios.post(`/referral`, {
    ...referralDetails,
  })
}

export const resendReferral = ({ referralDetails }, referralId) => {
  return axios.put(`/referral/${referralId}`, {
    ...referralDetails,
  })
}

export const getMyReceivedReferral = ({ id }) => {
  return axios.get(`/referral/received/${id}`)
}

export const getMyReceivedReferrals = () => {
  return axios.get(`/referral/received`)
}

export const hasReceivedExpiringReferrals = () => {
  return axios.get(`/referral/has-received-expiring`)
}

export const getLosByState = ({ state, seed, page, search, referralId, signal }) => {
  return axios.get(`/referral/search-lo-users/${state}`, {
    signal: signal,
    params: {
      seedOrder: seed,
      currentPage: page,
      search,
      referralId,
    },
  })
}

export const getOfficesByState = ({ state, seed, page, search, referralId, signal }) => {
  return axios.get(`/referral/search-offices/${state}`, {
    signal,
    params: {
      seedOrder: seed,
      currentPage: page,
      search,
      referralId,
    },
  })
}

export const getMyOfficeSentReferrals = () => {
  return axios.get(`/referral/office-sent`)
}

export const getMyOfficeSentReferral = ({ id }) => {
  return axios.get(`/referral/office-sent/${id}`)
}

export const getMyOfficeReferrals = () => {
  return axios.get(`/referral/office`)
}

export const getMyOfficeReferral = ({ id }) => {
  return axios.get(`/referral/office/${id}`)
}

export const getMyOfficeMlos = ({ state }) => {
  return axios.get(`/referral/search-office-lo-users/${state}`)
}

export const getMySentReferrals = () => {
  return axios.get(`/referral/sent`)
}

export const getMySentReferral = ({ id }) => {
  return axios.get(`/referral/sent/${id}`)
}

export const acceptMyReceivedReferral = ({ id }) => {
  return axios.put(`/referral/received/accept/${id}`)
}

export const declineMyReceivedReferral = ({ id }) => {
  return axios.put(`/referral/received/decline/${id}`)
}

export const acceptMySentReferral = ({ id }, userId) => {
  return axios.put(`/referral/sent/accept/${id}`, {
    user: { id: userId },
  })
}

export const expireMySentReferral = ({ id }) => {
  return axios.put(`referral/sent/expire/${id}`)
}

export const assignMyOfficeReferral = ({ id }, userId) => {
  return axios.put(`/referral/office/assign/${id}`, {
    user: { id: userId },
  })
}

export const declineMyOfficeReferral = ({ id }) => {
  return axios.put(`/referral/office/decline/${id}`)
}
